import {ISmuFactsheetService} from "./smu-factsheet-service";
import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {ISMUWithFactsheetType} from "../../lt-ng/soil-information";
import {Coordinate} from "ol/coordinate";

export interface IReportFromUrlService {
    showFactsheet(data: ISMUWithFactsheetType, pinCoordinate: Coordinate);
    init(mapService: IMapService);
}

export class ReportFromUrlService implements IReportFromUrlService {
    public static $inject = [
        '$location',
        '$rootScope',
        'smuFactsheetService'
    ]

    protected mapService: IMapService;

    constructor(protected $location: ng.ILocationService,
                protected $rootScope: ng.IRootScopeService,
                protected smuFactsheetService: ISmuFactsheetService) {
        const keyupListener = (evt: KeyboardEvent) => {
            if (evt.key !== "Escape") {
                return;
            }

            this.$rootScope.$apply(() => {
                const isFsActive = ($location.search() || {})['gislayer'];

                if (isFsActive) {
                    this.$location.search({});
                }
            });
        }

        window.addEventListener("keyup", keyupListener);
    }

    init(mapService: IMapService) {
        this.mapService = mapService;

        const showFs = () => {
            this.smuFactsheetService.showFactsheetForQuery(this.$location.search(), mapService);
        };

        this.$rootScope.$on('$locationChangeSuccess', showFs);
    }

    showFactsheet(data: ISMUWithFactsheetType, pinCoordinate: Coordinate) {
        const params = {
            ...data,
            pinCoordinate: pinCoordinate ? pinCoordinate.join(',') : undefined
        }

        this.$location.search(params);
    }
}
